import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=75c42316"
import script from "./ItemSelect.vue?vue&type=script&lang=js"
export * from "./ItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c42316')) {
      api.createRecord('75c42316', component.options)
    } else {
      api.reload('75c42316', component.options)
    }
    module.hot.accept("./ItemSelect.vue?vue&type=template&id=75c42316", function () {
      api.rerender('75c42316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/ItemSelect.vue"
export default component.exports